import React from 'react';

export const SectionHeader = ({ eyebrow, title, subtitle, children }) => (
  <div className="section-header">
    {eyebrow && <span className="section-eyebrow">{eyebrow}</span>}
    <h2 className="section-title section-title-flanked">
      <span className="section-title-text">{title}</span>
    </h2>
    {subtitle && <p className="body-large section-subtitle">{subtitle}</p>}
    {children}
  </div>
);
